import { render, staticRenderFns } from "./CollectionActionMail.vue?vue&type=template&id=19105806&scoped=true&"
import script from "./CollectionActionMail.vue?vue&type=script&lang=ts&"
export * from "./CollectionActionMail.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionActionMail.vue?vue&type=style&index=0&id=19105806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19105806",
  null
  
)

export default component.exports